import { render } from "./nav-switch.vue?vue&type=template&id=c29359bc&scoped=true"
import script from "./nav-switch.vue?vue&type=script&lang=ts"
export * from "./nav-switch.vue?vue&type=script&lang=ts"

import "./nav-switch.vue?vue&type=style&index=0&id=c29359bc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c29359bc"

export default script